import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import { EERIE } from 'HubStyleTokens/colors';
import { useState } from 'react';
import MobileNestedMenu from './MobileNestedMenu';
import { PanelSection } from './PanelSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRouteMatch, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MenuButton = styled(UIButton).withConfig({
  displayName: "MyLearningMobileModal__MenuButton",
  componentId: "sc-2krtj6-0"
})(["display:flex;flex-grow:1;justify-content:space-between;font-weight:initial;padding:12px 20px !important;"]);
const MyLearningMobileModal = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const match = useRouteMatch('/mylearning/:status');
  const status = match && match.params && match.params.status || 'in-progress';
  const history = useHistory();
  const LinkText = {
    'in-progress': /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.status.IN_PROGRESS"
    }),
    completed: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.status.COMPLETED"
    })
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UILink, {
      "data-test-id": "category-selector-panel-button",
      onClick: () => {
        setMenuOpen(true);
      },
      use: "blue",
      children: [LinkText[status], /*#__PURE__*/_jsx(UIIcon, {
        className: 'm-left-1',
        color: EERIE,
        name: "downCarat",
        size: 10
      })]
    }), /*#__PURE__*/_jsxs(MobileNestedMenu, {
      indented: false,
      open: menuOpen,
      setIsOpen: setMenuOpen,
      useBackText: false,
      useSidePanel: false,
      children: [/*#__PURE__*/_jsx(PanelSection, {
        showBorders: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.sidebarTitle"
        })
      }), /*#__PURE__*/_jsx(MenuButton, {
        onClick: () => {
          history.push('/mylearning/in-progress');
          setMenuOpen(false);
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.status.IN_PROGRESS"
        })
      }), /*#__PURE__*/_jsx(MenuButton, {
        onClick: () => {
          history.push('/mylearning/completed');
          setMenuOpen(false);
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.status.COMPLETED"
        })
      })]
    })]
  });
};
export default MyLearningMobileModal;